import React from "react";
import HeaderTopic from "../../partials/HeaderTopic";
import FooterMenu from "../../partials/FooterMenu";
import BasicButtons from "../../partials/BasicButtons";
import defualtGroupImg from "./../../graphics/elements/iconGroupPic.svg";
import { addNewGroup } from "../../api/addNewGroup";
import { useHistory, useParams } from "react-router";
import styles from "./AddNewGroup.module.css";

function AddNewGroup(props) {
  const { user, league, refreshStates } = props;
  const history = useHistory();
  const { leagueId } = useParams();

  const [groupName, setGroupName] = React.useState("");
  const [groupSlogan, setGroupSlogan] = React.useState("");
  const [groupImage, setGroupImage] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [textError, setTextError] = React.useState("");

  const validInputs = () => {
    if (groupName.length < 2) {
      return "שם הקבוצה אינו תקין";
    } else {
      return "np";
    }
  };

  const handleSubmit = async () => {
    setIsLoading(true);

    if (validInputs() === "np") {
      const res = await addNewGroup(
        leagueId,
        groupName,
        groupSlogan,
        groupImage
      );
      setIsLoading(false);


       if (res.status === 201) {
         history.push(`/leagues/${leagueId}`);
       } else {

       }
    } else {
      setTextError(validInputs());
      setIsLoading(false);
    }
  };

  return (
    <>
      <HeaderTopic topic={"ליגת " + league.name} />
      <BasicButtons user={user} refreshStates={refreshStates} />
      <FooterMenu setActive="league" />

      <form className={styles.addNewGroup}>
        <h2 className="sectionTitleSize">קבוצה חדשה</h2>
        <input
          type="text"
          placeholder="שם הקבוצה"
          required
          onChange={(e) => setGroupName(e.target.value)}
        />

        <input
          type="text"
          placeholder="סלוגן"
          onChange={(e) => setGroupSlogan(e.target.value)}
        />

        {!groupImage ? (
          <img width="170px" src={defualtGroupImg} alt="תמונת הקבוצה" />
        ) : (
          <img
            src={URL.createObjectURL(groupImage)}
            className={styles.groupImage}
            alt="תמונת הקבוצה"
          />
        )}

        <input
          className="hideMe"
          type="file"
          accept="image/png, image/jpeg"
          id="groupImage"
          onChange={(e) => setGroupImage(e.target.files[0])}
        />

        <button
          className="btnMedium"
          type="button"
          onClick={() => {
            const imgElem = document.querySelector(".hideMe");
            imgElem.click();
          }}
        >
          העלאת תמונה
        </button>

        <button
          disabled={isLoading}
          className="btnLarge"
          type="button"
          onClick={handleSubmit}
        >
          פתיחת קבוצה חדשה
        </button>
        <span className={styles.errorMsg}>{textError}</span>
      </form>
    </>
  );
}

export default AddNewGroup;
